import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'
import { isMirrorReady } from '@nsftx/seven-client-retail-cashier-mirror-core'
import { logService } from '@nsftx/seven-client-retail-utils'

const LOG_PREFIX = '[integratorCashierMirrorSettings]'

export const getCashierMirrorActiveSettings = () => {
  if (!isMirrorReady()) {
    return {}
  }

  return {
    cashierMirror: { active: true },
  }
}

export const pushCashierMirrorActiveToIntegrator = () => {
  if (!isMirrorReady()) {
    return
  }

  const { updateSettings } = useIntegrator<'pos'>()
  updateSettings({ cashierMirror: { active: true } })

  logService.debug(`${LOG_PREFIX} Integrator cashierMirror.active pushed.`, {
    code: 'SS_CASHIER_MIRROR_INTEGRATOR_ACTIVE',
  })
}
